export default "__VITE_ASSET__CMz6YeI8__"